import { gql } from "@/services/httpAdapter";

export const onUpdateAdvisorPerformance = gql`
	subscription onUpdateAdvisorPerformance($locationId: String, $payPeriodId: String) {
		onUpdateAdvisorPerformance(locationId: $locationId, payPeriodId: $payPeriodId) {
			locationId
			payPeriodId
		}
	}
`;
